import api from '@/api/api'

import Routes from '@/router/routes'

export default {
	name: 'client-record',
	data () {
		return {
			routes : Routes
		}
	},
	methods : {},
	components : {},
	created () {}
}


// WEBPACK FOOTER //
// ./src/components/private/clients-records/script.js